import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { deleteEventFavicon, updateEventFavicon } from "../../../../../../../store/actions/admin/create-event";

import { useTypedSelector } from "../../../../../../../store/reducers/use-typed-selector";
import { UploadButton } from "../../broadcast-card";

const FaviconUpload: React.FC = () => {
	const [, setUploading] = useState(false);

	const eventUuid = useTypedSelector(state => state?.CreateEventReducer?.workingEvent?.uuid);
	const favicon = useTypedSelector(state => state?.CreateEventReducer?.workingEvent?.favicon);
	const token = useTypedSelector(state => state?.AuthReducer.token);

	const dispatch = useDispatch();

	const handleStartUploading = useCallback(() => setUploading(true), []);

	const handleUploadedImage = useCallback((url: string) => {
		// upload to event favicon string
		if (!url || !token || !eventUuid) {
			setUploading(false);
			return;
		}
		dispatch(updateEventFavicon(token, url, eventUuid));
		setUploading(false);
	}, [dispatch, token, eventUuid]);

	const handleDeleteImage = useCallback(() => {
		// set favicon field to null
		if (!token || !eventUuid) return;
		dispatch(deleteEventFavicon(token, eventUuid));
	}, [dispatch, token, eventUuid]);

	if (!eventUuid) return null;
	return (
		<div className='event-main-navigation-container' style={{ marginTop: 32 }}>
			<div className="main-navigation-title">
				<h6>Favicon Settings</h6>
			</div>

			<div style={{ marginBottom: 16 }}>
				<UploadButton
					initialImage={favicon || undefined}
					onStartUpload={handleStartUploading}
					uploadedImage={handleUploadedImage}
					handleDeleteImage={handleDeleteImage}
					smaller={true}
					description="32 x 32px .png recommended"
				/>
			</div>
		</div>
	);
};

export default FaviconUpload;
